import React, {Component} from 'react';
import {Provider} from 'react-redux';
import {StaticRouter, Switch, Route} from 'react-router-dom';
import {Helmet, HelmetProvider} from 'react-helmet-async';
import {Store} from 'redux';

import commonHelmetJson from '../../src/utils/common-helmet.json';
import {ThemeProvider} from 'styled-components';

import {Header} from '@growth/dweb-header';
import Footer from '../../src/core-components/Footer/footer';
import {defaultTheme} from '../../src/utils/build-theme/build-theme';
import {GlobalStyles} from '../../src/utils/global-style';

interface AppProps {
  routes: any[];
  store: Store;
  url: string;
  footerParam?: Record<string, any>;
  hideHeader?: boolean;
  hideFooter?: boolean;
  styleParams?: any;
  stickyHeader?: boolean;
}

const App: React.FC<AppProps> = ({store, routes, url, footerParam, styleParams, hideHeader, hideFooter, stickyHeader = true}) => {
  let theme = defaultTheme;
  let style = <GlobalStyles />;
  if (styleParams && styleParams.theme) {
    theme = styleParams.theme;
  }
  if (styleParams && styleParams.Style) {
    const StyleComponent = styleParams.Style;
    style = <StyleComponent />;
  }

  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          {style}
          <StaticRouter location={url}>
            <Helmet {...commonHelmetJson} />
            {(!hideHeader && 
              <Header 
                location={{ pathname: url }} 
                sticky={stickyHeader} 
                lobName="cabs"
                onLoginSuccess={() => window.location.reload()}
                onLogoutSuccess={() => window.location.reload()}
              />) || null}
            <Switch>
              {routes.map(route => (
                <Route {...route} />
              ))}
            </Switch>
            {(!hideFooter && <Footer {...footerParam} />) || null}
          </StaticRouter>
        </Provider>
      </ThemeProvider>
    </HelmetProvider>
  );
};

export default App;
